import { app } from './main.js'

var fintiURLs = {
    local: 'http://localhost:5000/',
    test: 'https://sf-stage.oit.pdx.edu/',
    prod: 'https://ws.oit.pdx.edu/'
}

export async function fintiCall(path, method, data, subdomain) {
    const jwt = app.config.globalProperties.$jwt
    const appName = app.config.globalProperties.$appName
    let jwtData = jwt.read(appName)
    while (!jwtData || jwtData.otu) {
        await new Promise(r => setTimeout(r, 100))
        jwtData = jwt.read(appName)
    }
    
    const token = jwt.get(app.config.globalProperties.$appName)
    if (jwt.isExpired(token)) {
        throw "Your session has expired.  Please click the sign in button or refresh the page to continue."
    }

    if (!subdomain) {
        subdomain = "people/v1/bio_data/web"
    }
    const baseURL = fintiURLs[app.config.globalProperties.$envName] + subdomain
    const options = {
        url: baseURL + path,
        type: method,
        headers: {"Authorization" : "Bearer " + token},
    }
    
    if (data) {
        options.data = JSON.stringify(data)
        options.contentType = "application/json"
    }
    
    try {
        const response = await window.jQuery.ajax(options)
        if (response.jwt) {
            jwt.store(response.jwt, app.config.globalProperties.$appName)
        }
        
        return response.message
    }
    catch (response) {
        let message = "An error occured while " + (data?"submitting":"retrieving") + " your data. "
        if (response.getResponseHeader('Content-Type') == 'text/plain') {
            message += response.responseText
        }
        else if (response.responseJSON && response.responseJSON.message) {
            message += response.responseJSON.message
        }
        else {
            message += "Please reload the page and try again."
        }
        throw message
    }
}

var formsURLs = {
    local: 'http://localhost:8000/api',
    test: 'https://forms-stage.campus.wdt.pdx.edu/api',
    prod: 'https://forms.campus.wdt.pdx.edu/api'
}


export async function formsCall(path, method, data) {
    const baseURL = formsURLs[app.config.globalProperties.$envName]
    const options = {
        url: baseURL + path,
        type: method,
        data: data
    }

    try {
        const response = await window.jQuery.ajax(options)
        return response
    }
    catch (response) {
        let message = "An error occured while " + (data ? "submitting" : "retrieving") + " your data. "
        message += "Please reload the page and try again."
        throw message
    }
}

var emergencyURLs = {
    local: 'http://localhost:8000/emerg_contact/',
    test: 'https://forms-stage.campus.wdt.pdx.edu/emerg_contact/',
    prod: 'https://forms.campus.wdt.pdx.edu/emerg_contact/'
}

export function emergencyURL() {
    return emergencyURLs[app.config.globalProperties.$envName]
}
